import Repository from "../../repository";

export default {
    GetByCommentID: (payload) => Repository.post(`/api/CommentDetails/GetByCommentID`, payload),
    GetById: (payload) => Repository.post(`/api/CommentDetails/GetById`, payload),
    Add: (payload) => Repository.post(`/api/CommentDetails/Add`, payload),
    Edit: (payload) => Repository.post(`/api/CommentDetails/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/CommentDetails/Delete`, payload),
}
